export const PLAN_STATUSES = ['DRAFT', 'PLANNING', 'READY', 'RELEASING', 'RELEASED', 'CANCELLED'];
export const PRODUCT_READINESS = ['PREPARING', 'READY', 'ON_HOLD'];
export const PRODUCTION_READINESS = ['UNCHECKED', 'PREPARING', 'READY', 'BLOCKED', 'NOT_NEEDED'];
export const EVIDENCE_STATUSES = ['UNLINKED', 'FRESH', 'PARTIAL', 'STALE', 'UNAVAILABLE'];

const CLOSED_PLAN_STATUSES = new Set(['RELEASED', 'CANCELLED']);
const PLAN_TRANSITIONS = {
  DRAFT: ['PLANNING', 'CANCELLED'],
  PLANNING: ['READY', 'CANCELLED'],
  READY: ['PLANNING', 'RELEASING', 'CANCELLED'],
  RELEASING: ['READY', 'RELEASED'],
  CANCELLED: ['DRAFT'],
};

export function getAllowedPlanTransitions(status) {
  return PLAN_TRANSITIONS[status] || [];
}

export function planAllowsGeneralEdit(status) {
  return status === 'DRAFT' || status === 'PLANNING';
}

export function planAllowsItemEdit(status) {
  return !status || ['DRAFT', 'PLANNING', 'READY'].includes(status);
}

export function getNextReleasePlan(plans = []) {
  return plans
    .filter((plan) => !plan.deleted_at && !CLOSED_PLAN_STATUSES.has(plan.status))
    .slice()
    .sort((a, b) => {
      if (!a.target_date && b.target_date) return 1;
      if (a.target_date && !b.target_date) return -1;
      if (a.target_date !== b.target_date) return String(a.target_date).localeCompare(String(b.target_date));
      return Number(b.id) - Number(a.id);
    })[0] || null;
}

export function isPlanningApiUnavailable(error) {
  return error?.status === 404;
}

export function isRevisionConflict(error) {
  return error?.status === 409;
}

export function isOverdue(date, now = new Date()) {
  if (!date) return false;
  const end = new Date(`${String(date).slice(0, 10)}T23:59:59`);
  return !Number.isNaN(end.getTime()) && end < now;
}

export function getCodeReadiness(item) {
  if (!item?.repository || !item?.source_branch || item.evidence_status === 'UNLINKED') return 'UNLINKED';
  if (['PARTIAL', 'STALE', 'UNAVAILABLE'].includes(item.evidence_status)) return item.evidence_status;
  if (item.github_evidence?.merged_into_base === true) return 'MERGED';
  if ((item.github_evidence?.pull_requests || []).some((pull) => pull.state === 'OPEN')) return 'PR_OPEN';
  return 'WORKING';
}

export function getAttentionReasons(item, now = new Date()) {
  const reasons = [];
  if (isOverdue(item?.expected_ready_date, now) && item?.product_readiness !== 'READY') reasons.push('OVERDUE');
  const code = getCodeReadiness(item);
  if (code !== 'MERGED') reasons.push(`CODE_${code}`);
  if (item?.product_readiness === 'ON_HOLD') reasons.push('PRODUCT_ON_HOLD');
  if (item?.production_readiness === 'BLOCKED') reasons.push('PRODUCTION_BLOCKED');
  return reasons;
}

export function toItemUpdatePayload(item, overrides = {}) {
  const next = { ...item, ...overrides };
  return {
    product_id: Number(next.product_id),
    plan_id: next.plan_id == null || next.plan_id === '' ? null : Number(next.plan_id),
    release_item: String(next.release_item || '').trim(),
    owner_user_id: Number(next.owner_user_id),
    expected_ready_date: next.expected_ready_date ? String(next.expected_ready_date).slice(0, 10) : null,
    repository: next.repository || null,
    source_branch: next.source_branch || null,
    product_readiness: next.product_readiness,
    production_readiness: next.production_readiness,
    discussion_url: next.discussion_url || null,
    note: next.note || null,
  };
}

export function toPlanUpdatePayload(plan, overrides = {}) {
  const next = { ...plan, ...overrides };
  return {
    version_name: String(next.version_name || '').trim(),
    status: next.status,
    coordinator_user_id: next.coordinator_user_id == null || next.coordinator_user_id === '' ? null : Number(next.coordinator_user_id),
    target_date: next.target_date ? String(next.target_date).slice(0, 10) : null,
    note: next.note || null,
  };
}
